/**
 * combine reducer without validations
 * remember following the rules of reducers.
 * compatible with reducer-reducers
 * @param reducers
 * @returns {function(*=, *=): string}
 */
export function combineReducers(reducers) {
  const cleanReducers = Object.keys(reducers).reduce((memo, key) => {
    if (typeof reducers[key] === 'undefined') {
      return memo;
    }

    if (typeof reducers[key] !== 'function') {
      return memo;
    }

    return {
      ...memo,
      [key]: reducers[key]
    };
  }, {});
  // eslint-disable-next-line default-param-last
  return (state = {}, action) => {
    let hasChanged = false;

    const nextState = Object.keys(cleanReducers).reduce((memo, key) => {
      const reducer = cleanReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        return memo;
      }

      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
      return {
        ...memo,
        [key]: nextStateForKey
      };
    }, state);

    return hasChanged ? nextState : state;
  };
}

export default combineReducers;
